import { formatCurrency } from '../receptionistData';
import { sumPaymentSplits } from '../../../utils/splitPaymentUtils';
import SplitPaymentFields from './SplitPaymentFields';

export default function SaleAmountFields({
  idPrefix,
  totalAmount,
  paymentSplits,
  onTotalChange,
  onPaymentSplitsChange,
  onSplitsTouched,
  totalReadOnly = false,
}) {
  const amountBlank = String(totalAmount ?? '').trim() === '';
  const total = Number(totalAmount) || 0;
  const paid = sumPaymentSplits(paymentSplits);
  const pending = Math.max(0, total - paid);

  const handleSplitsChange = (nextSplits) => {
    onSplitsTouched?.();
    onPaymentSplitsChange(nextSplits);
  };

  return (
    <>
      <div className="owner-form-group">
        <label className="owner-form-label" htmlFor={`${idPrefix}-amount`}>
          Total amount
        </label>
        {totalReadOnly ? (
          <p className="owner-form-input rec-sale-total-readonly" style={{ margin: 0 }}>
            {formatCurrency(total)}
          </p>
        ) : (
          <input
            id={`${idPrefix}-amount`}
            name="amount"
            type="text"
            inputMode="decimal"
            className="owner-form-input"
            value={totalAmount == null ? '' : String(totalAmount)}
            onChange={onTotalChange}
            placeholder="Optional — leave blank to set later"
          />
        )}
      </div>

      <div className="owner-form-group rec-ancillary-sale-full">
        <SplitPaymentFields
          idPrefix={idPrefix}
          splits={paymentSplits}
          onChange={handleSplitsChange}
        />
      </div>

      <div className="owner-form-group rec-sale-payment-summary rec-ancillary-sale-full">
        <p className="owner-placeholder-text" style={{ margin: 0, fontSize: 13 }}>
          {amountBlank ? (
            <>Total amount not set — you can edit this sale later.</>
          ) : (
            <>
              Total paid: <strong>{formatCurrency(paid)}</strong>
              {total > 0 && paid <= 0 ? ' · Pay later (edit sale when customer pays)' : ''}
              {total <= 0 && !amountBlank ? ' · Free sale (0 total)' : ''}
            </>
          )}
        </p>
        {!amountBlank && (
          <p className="rec-sale-pending-amount">
            Pending amount: <strong>{formatCurrency(pending)}</strong>
          </p>
        )}
      </div>
    </>
  );
}
